import { useFlashToast } from '../hooks/useFlashToast'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroSection from '../components/sections/HeroSection'
import TentangSection from '../components/sections/TentangSection'
import JenisPelanggaranSection from '../components/sections/JenisPelanggaranSection'
import CaraKerjaSection from '../components/sections/CaraKerjaSection'
import FiturSection from '../components/sections/FiturSection'
import CtaSection from '../components/sections/CtaSection'
import FaqSection from '../components/sections/FaqSection'

export default function Home({ documents = [] }) {
  useFlashToast()
  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <Navbar />
      <HeroSection />
      <TentangSection documents={documents} />
      <JenisPelanggaranSection />
      <CaraKerjaSection />
      <FiturSection />
      <CtaSection />
      <FaqSection />
      <Footer />
    </div>
  )
}

